import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { businessMenus } from '../data/businessMenus';

const Intro = styled.p`
  font-size: 1.05rem;
  color: #555;
  line-height: 1.9;
  margin-bottom: 50px;
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 50px;
`;

const ServiceCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px 25px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 86, 179, 0.1);
    border-color: #0056b3;
  }

  .icon { font-size: 2rem; margin-bottom: 12px; }
  h4 { font-size: 1.1rem; color: #222; margin-bottom: 8px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.7; }
`;

const SectionLabel = styled.h3`
  font-size: 1.3rem;
  color: #1a2a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
`;

const FeatureBox = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #0056b3;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 15px;

  h4 { font-size: 1rem; color: #333; margin-bottom: 6px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.6; }
`;

const BusinessMetal = () => {
  return (
    <SubLayout
      title="금속구조물·지붕건축물조립"
      sidebarMenus={businessMenus}
      category="사업영역"
      categoryEn="Business"
      bannerBg="/images/bg_building.jpg"
    >
      <Intro>
        주식회사 두성시스템은 금속구조물·지붕건축물조립공사업 면허를 바탕으로,
        <strong> 지붕판금 및 건축물조립공사를 주력분야</strong>로 수행합니다.
        정밀한 시공 기술과 안전 관리를 통해 견고하고 내구성 높은 금속 구조물과 지붕을 완성합니다.
      </Intro>

      <SectionLabel>주요 서비스</SectionLabel>
      <ServiceGrid>
        <ServiceCard>
          <div className="icon">🏠</div>
          <h4>지붕판금공사</h4>
          <p>금속 지붕재 시공 및 판금 가공으로 방수·단열 성능이 우수한 지붕을 완성합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🏗️</div>
          <h4>건축물 조립공사</h4>
          <p>조립식 건축물 및 철골 구조물의 제작·설치 공사를 전문적으로 수행합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🔩</div>
          <h4>금속구조물 제작·설치</h4>
          <p>각종 금속구조물을 설계·제작하여 현장 여건에 맞게 정밀 설치합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🧱</div>
          <h4>판넬·샌드위치판넬 시공</h4>
          <p>단열 판넬 시공으로 효율적인 벽체 및 지붕 마감을 구현합니다.</p>
        </ServiceCard>
      </ServiceGrid>

      <SectionLabel>특장점</SectionLabel>
      <FeatureBox>
        <h4>지붕판금 전문 시공</h4>
        <p>주력분야인 지붕판금공사에서 축적된 노하우로 누수 없는 완벽한 시공을 보장합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>정밀 조립 기술</h4>
        <p>정확한 계측과 시공 관리를 통해 구조적으로 안전한 건축물 조립을 실현합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>철저한 안전 관리</h4>
        <p>고소 작업 및 중량물 취급에 대한 체계적인 안전 관리로 무재해 시공을 지향합니다.</p>
      </FeatureBox>
    </SubLayout>
  );
};

export default BusinessMetal;
